import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { InputMask } from "@/components/ui/input-mask";
import { toast } from "@/components/ui/use-toast";
import AcessoService from "@/services/AcessoService";
import { MASCARA_CPF } from "@/utils/Constants";
import { normalizarCPF, validarCPF } from "@/utils/Cpf";
import { useFormik } from "formik";
import * as Yup from 'yup';

interface AutenticarPorCodigoStepInicialProps {
    handleInicial: (emailValido: boolean, cpf: string, destino: string) => void;
}

export function AutenticarPorCodigoStepInicial({ handleInicial }: AutenticarPorCodigoStepInicialProps) {
    const formik = useFormik({
        initialValues: {
            cpf: '',
        },
        validationSchema: Yup.object({
            cpf: Yup.string()
                .required('Obrigatório')
                .test('Validar CPF', 'CPF Inválido', cpfToValidate => {
                    return validarCPF(cpfToValidate || '');
                }),
        }),
        onSubmit: async (values) => {
            try {
                const cpf = normalizarCPF(values.cpf);


                const recaptchaToken = await verificarRecaptcha();
                if (!recaptchaToken) {
                    toast({
                        variant: 'destructive',
                        description: 'Erro ao verificar recaptcha',
                        duration: 3000
                    });
                    return;
                }

                const { Data: result } = await AcessoService.obterCodigoVerificacaoCliente(cpf, recaptchaToken);
                handleInicial(result.EmailValido, cpf, result.Destino);
            } catch (error) {
                toast({
                    variant: 'destructive',
                    description: 'CPF Inválido',
                    duration: 3000
                });
            }
        }
    })

    async function verificarRecaptcha() {
        try {
            const grecaptcha = (window as any).grecaptcha;
            const token = await grecaptcha.execute('6LdL-BcsAAAAAMp9u6pw0p90qR518KgqzfiSihU3', { action: 'submit' })!;
            return token;
        } catch (error: any) {
            toast({
                variant: 'destructive',
                description: error,
                duration: 4000
            });
            return null;
        }
    }

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <Card className="mx-auto max-w-sm p-5 mb-5">
                    <h1 className="text-center text-primary font-semibold">
                        Insira seu CPF
                    </h1>
                    <InputMask
                        disabled={formik.isSubmitting}
                        type="text"
                        id="cpf"
                        className="text-center text-primary text-2xl"
                        required
                        formik={formik}
                        name='cpf'
                        mask={MASCARA_CPF}
                    />
                    <div className="flex justify-center gap-2 mt-5">
                        <Button
                            disabled={!formik.isValid || formik.isSubmitting
                            }
                            type="submit"
                            variant="foreground"
                            className="mt-2">
                            {
                                formik.isSubmitting ? <span>Pesquisando...</span> : <span>Pesquisar</span>
                            }
                        </Button>
                    </div>
                </Card>
            </form>
        </>
    )
}